import React from 'react';

import { flagStyles } from '../settings';

const SvgLK = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-3072px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgLK;
